import type { ProductTemplate } from '../../../api/types';
import { inpSt, selSt } from './sharedStyles';

function parseOptions(opts: string | null | undefined): string[] {
  if (!opts) return [];
  const s = opts.trim();
  if (s.startsWith('[')) { try { return JSON.parse(s) as string[]; } catch { /* fall through */ } }
  return s.split('\n').map(o => o.trim()).filter(Boolean);
}

export function AttributeValuesEditor({
  template, values, onChange,
}: {
  template: ProductTemplate;
  values: Record<string, unknown>;
  onChange: (v: Record<string, unknown>) => void;
}) {
  if (!template.attributes || template.attributes.length === 0) return null;

  return (
    <div style={{ marginTop: '0.5rem', padding: '0.625rem', background: 'var(--glass-bg-card)', borderRadius: 'var(--radius-interactive)', border: '1px dashed rgba(255,255,255,0.10)' }}>
      <p style={{ fontSize: 'var(--text-xs)', fontWeight: 600, color: 'var(--color-text-faint)', marginBottom: '0.5rem' }}>
        Attributi prodotto
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '0.5rem' }}>
        {template.attributes.map(attr => {
          const val = values[attr.key] ?? attr.defaultValue ?? '';
          const upd = (v: unknown) => onChange({ ...values, [attr.key]: v });
          return (
            <div key={attr.key} style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
              <label style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-muted)', fontWeight: 500 }}>
                {attr.key}{attr.isRequired ? ' *' : ''}{attr.unit ? ` (${attr.unit})` : ''}
              </label>
              {attr.attributeType === 'SELECT' ? (
                <select value={String(val)} onChange={e => upd(e.target.value)} style={selSt}>
                  <option value="">— scegli —</option>
                  {parseOptions(attr.options).map((o: string) =>
                    <option key={o} value={o}>{o}</option>
                  )}
                </select>
              ) : attr.attributeType === 'BOOLEAN' ? (
                <select
                  value={val === true || val === 'true' ? 'true' : val === false || val === 'false' ? 'false' : ''}
                  onChange={e => { if (e.target.value !== '') upd(e.target.value === 'true'); }}
                  style={selSt}
                >
                  <option value="">— scegli —</option>
                  <option value="true">Sì</option>
                  <option value="false">No</option>
                </select>
              ) : attr.attributeType === 'NUMBER' ? (
                <input type="number" value={String(val)} onChange={e => upd(Number(e.target.value))} style={inpSt} />
              ) : (
                <input type="text" value={String(val)} onChange={e => upd(e.target.value)} style={inpSt} placeholder={attr.defaultValue ?? ''} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
